import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const getLocaleDate = (date: number | string | null | undefined, format = 'MM/DD hh:mm a') => {
  if (!date) {
    return 'N/A';
  }
  dayjs.extend(utc);

  return dayjs.utc(date).local().format(format);
};

export { getLocaleDate };
